import apiClient from './apiClient';

// ============================================================
// Types — aligned with backend models (backend/modules/pwp303/models/pwp303.go)
// ============================================================

/** QueryRequest matches backend models.QueryRequest JSON tags exactly. */
export interface QueryRequest {
  deliveryNoFrom: string;   // FP230_18 lower bound
  deliveryNoTo: string;     // FP230_18 upper bound
  deliverySeqFrom: number;  // FP230_19 lower bound (0-99)
  deliverySeqTo: number;    // FP230_19 upper bound (0-99)
  submitNoFrom: string;     // FP230_13 lower bound
  submitNoTo: string;       // FP230_13 upper bound
  testDateFrom: string;     // FP230_12 lower bound (ISO date, e.g. "2026-01-01")
  testDateTo: string;       // FP230_12 upper bound (ISO date)
  reportNoFrom: string;     // FP230_01 lower bound
  reportNoTo: string;       // FP230_01 upper bound
}

/** FP231Item matches backend models.FP231Item JSON tags exactly. */
export interface FP231Item {
  fp231_02: number;    // sequence number
  fp231_11: number;    // test item code (FK to F11A_01)
  f11a_11: string;     // test item name
  f11a_15: number | null; // output format (1-5)
}

/** FP230Row matches backend models.FP230Row JSON tags exactly. */
export interface FP230Row {
  fp230_01: string;            // report number (PK)
  fp230_11: string | null;     // report date
  fp230_12: string | null;     // test completion date
  fp230_121: string;           // tester code
  fp230_13: string;            // submit number
  fp230_14: string;            // color code
  fp230_15: number | null;     // count
  fp230_16: string;            // color name code
  fp230_17: string;            // related code
  fp230_18: string;            // delivery number
  fp230_19: number | null;     // delivery sequence
  fp230_20: string;            // status code
  fp230_411: string;           // product code 1
  fp230_412: string;           // product code 2
  fp230_80: string;            // approval status
  fp230_801: string;           // approver
  fp230_802: string;           // approval related
  fp230_91: string;            // last modifier
  fp230_92: string | null;     // last modified date
  testItems: FP231Item[];      // FP231 detail rows enriched with F11A info
}

/** QueryResponse matches backend models.QueryResponse JSON tags exactly. */
export interface QueryResponse {
  data: FP230Row[];
  totalCount: number;
}

// ============================================================
// API Client
// ============================================================

export const pwp303Api = {
  /** POST /api/pwp303/query — execute physical test report query. */
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post<QueryResponse>('/api/pwp303/query', req);
    return res.data;
  },
};
